<template>
  <div class="demo-spin-article">
    <Row class="ls_action_header mb-50" style="padding-top: 5px" type="flex" justify="space-between">

      <Col :xs="{order:2, span: 24}" :sm="{order:2, span: 24}" :md="{order:2, span: 24}" :lg="{order:1, span: 0}">
        <Row type="flex" :gutter="24">
          <!-- BULK DELETE -->
          <Col class="mb-10" :xs="{order:2, span: 24}" :sm="{order:2, span: 12}" :md="{order:2, span: 12}" :lg="{order:1, span: 0}">
            <!-- BULK ACTIONS-->
            <Button
              v-if="display_delete_button"
              type="error"
              class="ls_bulk_delete_button w-lg-100"
              :disabled="selected.length === 0"
              @click.native="bulkDelete"
            >Удалить
            </Button>
            <div v-else style="padding: 1px"></div>
          </Col>

          <!-- TEXT SEARCH -->
          <Col class="mb-10" :xs="{order:1, span: 24}" :sm="{order:1, span: 24}" :md="{order:1, span: 24}" :lg="{order:2, span: 0}">
            <Input
              placeholder="Введите наименование поставщика"
              class="search-input"
              v-model="searchString"
            >
              <Icon type="ios-search" slot="suffix" />
            </Input>


          </Col>

          <Col class="mb-10" :xs="{order:3, span: 24}" :sm="{order:3, span: 12}" :md="{order:3, span: 12}" :lg="{order:3, span: 0}">
            <Button v-if="showClearFilter"
                    @click="clearFilter"
                    type="error"
                    class="w-lg-100"
            >Сбросить фильтр</Button>
          </Col>
        </Row>
      </Col>




      <!-- CREATE -->
      <Col class="mb-10" :xs="{order:1, span: 24}" :sm="{order:1, span: 24}" :md="{order:1, span: 24}" :lg="{order:2, span: 0}">
        <!-- CREATE -->
        <Button
          v-if="display_create_button"
          type="success"
          class="ls_create_right_button w-lg-100"
          :to="{ name: item_type + '_create' }">
          <span class="d-flex align-center" style="justify-content: center">
          Создать
          <img src="/static/svg/create_white.svg" alt="">
          </span>
        </Button>
      </Col>
    </Row>

    <!-- DATA TABLE + PAGINATION -->
    <Table
      class="desktop_table"
      :loading="loading"
      :columns="columns"
      :data="data"
      @on-sort-change="changeSorting"
      @on-selection-change="onSelectChange"
    ></Table>

    <!-- DATA MOBILE TABLE -->
    <div class="mobile-table">

      <div v-for="item in data" class="card-container">
        <router-link :to="item_type + '/detail/' + item.id">
          <h2>{{item.name}}</h2>
          <p>Телефон: {{item.phone}}</p>
          <p>Email: {{item.email}}</p>
          <p>Адрес: {{item.address_legal}}</p>
        </router-link>

        <div>
          <div>
            <input type="checkbox" v-model="selected" :value="item.id">
          </div>
        </div>
      </div>
    </div>


    <Page
      :total="totalRecords"
      :page-size="pageSize"
      :page-size-opts="[15, 25, 35]"
      @on-change="changePage"
      @on-page-size-change="changePageSize"
      show-sizer
      :styles="{ marginTop: '30px', float: 'right' }"
    />

    <!-- ITEM VIEW -->
    <supplierItem
      :id="item.id"
      :action="item.action"
      v-model="item.show"
      @reload-table="fetchItems"
      :base_view_url="baseViewUrl"
      :item_type="item_type"
    ></supplierItem>



    <!--Modal for remove Item-->
    <Modal
      :footer-hide="footerHide"
      v-model="removeModal"
      title="">

      <h3 class="mb-40">Вы действительно хотите удалить данного поставщика?</h3>

      <Row type="flex" justify="center">
        <Button type="error" @click="removeModal = false">Отмена</Button>
        <Button type="success" style="margin-left: 12px"
                @click="deleteItem(removeId)">
          Удалить
        </Button>
      </Row>
    </Modal>


  </div>
</template>
<script>
import { base_url } from "../../http.js";
import { BaseTableData } from "../../base/base_table.js";
import supplierItem from "@/apps/supplier/supplierItem.vue";

let _app = BaseTableData();
_app.components = {
  supplierItem
};

_app.data = function() {
  return {
    // Base settings
    baseViewUrl: base_url + "/suppliers/",
    item_type: "supplier",
    loading: true,


      removeModal: false,
      removeId: null,
      footerHide: true,

    // Table settings
    columns: [
      {
        type: "selection",
        width: 40,
        align: "center"
      },
      {
        title: "Наименование",
        // width: 340,
        key: "name",

        render: (h, params) => {
          return h(
            "router-link",
            {
              props: {
                to: {
                  name: this.item_type + "_detail",
                  params: { id: params.row.id }
                }
              }
            },
            params.row.name
          );
        }
      },
      {
        title: "Телефон",
        // width: 80,
        key: "phone",
          align: "center",
      },
      {
        title: "Email",
        // width: 80,
        key: "email",
          align: "center",
      },
      {
        title: "Адрес",
        // width: 60,
        key: "address_legal",
          align: "center",
      },
      {
        title: "Действия",
        // key: 'action',
        width: 150,
        align: "center",
        render: (h, params) => {
          let buttons = [];
          if (this.display_edit_button_by_row(params.row)) {
            buttons.push(
              h(
                "Tooltip",
                {
                  props: {
                    content: "Редактировать"
                  }
                },
                [
                  h("Button", {
                    props: {
                      to: {
                        name: this.item_type + "_edit",
                        params: { id: params.row.id }
                      },
                      type: "primary",
                      size: "small",
                      // icon: 'ios-information-circle-outline',
                        icon: "md-create",
                    },
                    style: {
                        display: "flex", alignItems: "center", boxShadow: "none", background: "transparent", border: "none", color: "#DEDEDE",
                    }
                  })
                ]
              )
            );
          }
          if (this.display_delete_button_by_row(params.row)) {
            buttons.push(
              h(
                "Tooltip",
                {
                  props: {
                    content: "Удалить"
                  }
                },
                [
                  h("Button", {
                    props: {
                      type: "error",
                      size: "small",
                        icon: "md-trash",
                    },
                    on: {
                      click: () => {
                          this.removeModal = true;
                          this.removeId = params.row.id;
                      }
                    },
                      style: {
                          display: "flex", alignItems: "center", boxShadow: "none", background: "transparent", border: "none", color: "#DEDEDE",
                      }
                  })
                ]
              )
            );
          }

          return h("div", buttons);
        }
      }
    ],
    data: [],
    lastDraw: 0,
    totalRecords: null,
    currentPage: 1,
    pageSize: 15,
    sorting: "",
    searchString: "",

    filterShow: false,
    filter: {
      // type: "",
      // applied: "",
      // order_date__gt: "",
      // order_date__lt: ""
    },
    filterOptions: {
      // type: [
      //   {
      //     value: "coming",
      //     label: "Приход"
      //   },
      //   {
      //     value: "outgoing",
      //     label: "Расход"
      //   }
      // ],
      // applied: [
      //   {
      //     value: "true",
      //     label: "Проведен"
      //   },
      //   {
      //     value: "false",
      //     label: "Не проведен"
      //   }
      // ]
    },

    // filterOrderDate: ["", ""],
    selected: [],

    item: {
      show: false,
      id: null,
      action: null
    }
  };
};

// Очистка фильтров
_app.methods.clearFilter = function(val) {
  // Очистка общих фильтров и посика
  if (this.searchString) {
    this.searchString = "";
  }
};

export default _app;
</script>

<style scoped>
  .search-input {
    width: 400px;
  }
  @media screen and (max-width: 1900px) {
    .search-input {
      width: 380px;
    }
  }

  @media screen and (max-width: 1500px) {
    .search-input {
      width: 380px;
    }
  }

  @media screen and (max-width: 991px) {
    .w-lg-100 {
      width: 100%;
    }

    .search-input {
      width: 100%;
    }
  }
</style>

<style>
  @media screen and (min-width: 992px) {
    .ivu-col-span-lg-0 {
      display: block;
      width: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/supplier/supplier.vue